.close-button-container {
  text-align: right;
  float: right;
  padding-right: 12px;
  padding-top: 10px;
}

.close-button {
  cursor: pointer;
}

.close-button svg {
  width: 1rem;
}
